import { applySnapshot, cast, types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';

import {
  Api,
  ITariffPlansRequestParams,
  ITariffPlansResponse,
} from '@api';
import { IAPService } from '@services';
import { TariffPlanModel, TariffPlan } from './TariffPlanModel';
import { TariffPlanSaveModel } from './TariffPlanSaveModel';
import { IS_MOBILE } from '@utils';
import { TARIFF_CODE_BY_SUBSCRIPTION_ID } from '@constants';

export class TariffPlans extends Model({
  plans: types.optional(types.array(TariffPlanModel), []),
  save: types.optional(types.array(TariffPlanSaveModel), []),
  couponActivate: types.maybeNull(types.boolean),
}) {
  get byCode(): Record<number, TariffPlan | undefined> {
    return this.plans.reduce(
      (acc, item) => ({
        ...acc,
        [item.code]: item,
      }),
      {},
    );
  }

  private _setPlans(plans: TariffPlan[]) {
    this.plans = cast(plans);
  }

  private _updateModel(newData: ITariffPlansResponse) {
    applySnapshot(this, newData);
  }

  fetchPlans = createThunk((params?: ITariffPlansRequestParams) => {
    return async function fetchPlans(this: TariffPlans) {
      if (IS_MOBILE) {
        const res = await IAPService.getAllSubscriptions();

        const plans = res.map((s) => ({
          price: {
            current: s.price,
            regular: s.price,
            currency: s.currency,
            localizedCurrent: s.localizedPrice,
            localizedRegular: s.localizedPrice,
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          code: TARIFF_CODE_BY_SUBSCRIPTION_ID[s.productId],
        }));

        this._setPlans(plans as TariffPlan[]);
      } else {
        const res = await Api.Payments.getTariffPlanPrices({
          referrer: params?.referrer,
        });

        this._updateModel(res.data);
      }
    };
  });
}

export const TariffPlansModel = model(TariffPlans);
